module.exports = __webpack_public_path__ + "img/energy_bg.b0ca8115.png";